module.exports = __webpack_public_path__ + "img/menual01.643a37a2.png";